import { render, staticRenderFns } from "./SignUpCustomer.vue?vue&type=template&id=517cc50b&"
import script from "./SignUpCustomer.vue?vue&type=script&lang=js&"
export * from "./SignUpCustomer.vue?vue&type=script&lang=js&"
import style0 from "./SignUpCustomer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports